import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import './PublicOffer.css';

function PublicOffer() {
  const navigate = useNavigate();

  return (
    <div className="public-offer-page">
      <div className="public-offer-container">
        <button className="public-offer-back" onClick={() => navigate(-1)}>
          <ArrowLeft size={20} />
          Назад
        </button>
        
        <div className="public-offer-content">
          <h1>Публичная оферта</h1>
          
          <section>
            <h2>1. Общие положения</h2>
            <p>
              Настоящий документ является публичной офертой (далее — «Оферта») ООО "САХА КОНТЕНТ" 
              (далее — «Исполнитель») о заключении договора на оказание услуг по использованию 
              сервиса Pikly (далее — «Сервис») на условиях, изложенных ниже.
            </p>
            <p>
              В соответствии с пунктом 2 статьи 437 Гражданского кодекса Российской Федерации, 
              в случае принятия изложенных ниже условий лицо, производящее акцепт этой оферты, 
              становится Заказчиком (далее — «Пользователь»), а Исполнитель и Пользователь совместно — 
              «Стороны».
            </p>
          </section>

          <section>
            <h2>2. Предмет договора</h2>
            <p>
              Исполнитель обязуется предоставить Пользователю доступ к Сервису для генерации 
              контента с использованием искусственного интеллекта, а Пользователь обязуется 
              оплатить предоставленные услуги в порядке и на условиях, установленных настоящей Офертой.
            </p>
          </section>

          <section>
            <h2>3. Права и обязанности сторон</h2>
            <h3>3.1. Исполнитель обязуется:</h3>
            <ul>
              <li>Предоставить Пользователю доступ к функционалу Сервиса</li>
              <li>Обеспечить работоспособность Сервиса в соответствии с техническими возможностями</li>
              <li>Обрабатывать персональные данные Пользователя в соответствии с законодательством</li>
              <li>Обеспечить конфиденциальность данных Пользователя</li>
            </ul>

            <h3>3.2. Пользователь обязуется:</h3>
            <ul>
              <li>Использовать Сервис в соответствии с его назначением</li>
              <li>Не нарушать права третьих лиц при использовании Сервиса</li>
              <li>Не использовать Сервис для незаконных целей</li>
              <li>Своевременно оплачивать предоставленные услуги</li>
            </ul>
          </section>

          <section>
            <h2>4. Стоимость услуг и порядок расчетов</h2>
            <p>
              Стоимость услуг определяется в соответствии с тарифами, размещенными на сайте Сервиса. 
              Оплата услуг осуществляется путем пополнения баланса токенов Пользователя.
            </p>
            <p>
              Исполнитель вправе изменять тарифы в одностороннем порядке с уведомлением Пользователей 
              не менее чем за 7 дней до вступления изменений в силу.
            </p>
          </section>

          <section>
            <h2>5. Ответственность сторон</h2>
            <p>
              Исполнитель не несет ответственности за невозможность использования Сервиса по причинам, 
              не зависящим от Исполнителя, включая, но не ограничиваясь: сбоями в работе интернета, 
              действиями третьих лиц, форс-мажорными обстоятельствами.
            </p>
            <p>
              Пользователь несет полную ответственность за содержание создаваемого контента и соблюдение 
              прав третьих лиц.
            </p>
          </section>

          <section>
            <h2>6. Интеллектуальная собственность</h2>
            <p>
              Все права на результаты интеллектуальной деятельности, созданные с использованием Сервиса, 
              принадлежат Пользователю, при условии соблюдения условий настоящей Оферты и законодательства.
            </p>
          </section>

          <section>
            <h2>7. Изменение и расторжение договора</h2>
            <p>
              Исполнитель вправе в одностороннем порядке изменять условия настоящей Оферты. 
              Изменения вступают в силу с момента их публикации на сайте Сервиса.
            </p>
            <p>
              Пользователь вправе прекратить использование Сервиса в любое время. 
              Исполнитель вправе прекратить предоставление услуг в случае нарушения Пользователем 
              условий настоящей Оферты.
            </p>
          </section>

          <section>
            <h2>8. Реквизиты Исполнителя</h2>
            <p>
              <strong>ООО "САХА КОНТЕНТ"</strong><br />
              ИНН 1400007690<br />
              ОГРН 1221400004297<br />
              Регистрационный номер 14-25-002616 в Реестре операторов РКН
            </p>
          </section>

          <section>
            <p className="public-offer-date">
              Дата последнего обновления: {new Date().toLocaleDateString('ru-RU')}
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default PublicOffer;

